import React, { useEffect, useState, memo } from "react";
import { Controller } from "react-hook-form";


const ProductsFormA= memo(({register, defaultKanta, onChangeProducts, errors}) => {

    const [selectKantakun, setSelectKantakun] = useState(defaultKanta)
    
    const selectProducts = (event) => {

        setSelectKantakun(event.target.value)
   
        onChangeProducts(
            {   
                name:'ガス衣類乾燥機 乾太くん',
                kantakun: event.target.value,
                maker:''
            }
        )
    }

    const kantakun = [
        '9kg',
        '8kg',
        '5kg',
        '3kg'
    ]
    

    return (
        <>
        <div className="mb-10">ご購入日</div>
        <input type="date" name="buyDate" className="f-text" placeholder="例)2023/01/01" {...register("buyDate",{ required:true })}/>
        <span className="form_validation">{errors.buyDate && "エラー：未入力"}</span>

        <div className="flex-resp flex-center mt-20">
            <div>ガス衣類乾燥機</div>
            <div>
                <div className="f-radio">
                    {
                        kantakun.map((k,i) => {
                            let checked
                            selectKantakun === k ? checked = true : checked = false
                            return (
                                <span key={i}>
                                      <input type="radio" 
                                        value={k}
                                        id={`kantakun${i}`} 
                                        onChange={selectProducts}
                                        checked={checked}
                                        />
                                    <label htmlFor={`kantakun${i}`} >{k}</label>
                                </span>
                            )
                        })
                    }
                </div>
            </div>
        </div>
        </>
    )
})


const ProductsFormB= memo(({register, defaultGaskigu, onChangeProducts, errors}) => {

    const gaskigu = [
        'Siセンサーコンロ',
        'エコジョーズ',
        'ガスファンヒーター',
        'ガス炊飯器',
        'エネファーム',
        'ハイブリッド給湯器',
        '温水暖房(床暖房・浴室暖房乾燥機等)'
    ]

    const [selectGaskigu, setSelectGaskigu] = useState(defaultGaskigu)
    
    const selectProducts = (event) => {

        setSelectGaskigu(event.target.value)
   
        onChangeProducts(
            {   
                name: event.target.value,
            }
        )
    }

    return (
        <>

        <div className="f-radio mb-20">
            {
                gaskigu.map((g,i) => {
                    let checked
                    selectGaskigu === g ? checked = true : checked = false
                    return (
                        <span key={i}>
                            <input type="radio" 
                                value={g}
                                id={`gaskigu${i}`} 
                                onChange={selectProducts}
                                checked={checked}
                                />
                            <label htmlFor={`gaskigu${i}`} >{g}</label>
                        </span>
                    )
                })
            }
            
        </div>
        <div className="mb-10">メーカー名</div>
        <input type="text" name="maker" className="f-text" placeholder="メーカー名" {...register("maker",{ required:true })}/>
        <span className="form_validation">{errors.maker && "エラー：未入力"}</span>
        <div className="mb-10 mt-20">ご購入日</div>
        <input type="date" name="buyDate" className="f-text" placeholder="例)2023/01/01" {...register("buyDate",{ required:true })}/>
        <span className="form_validation">{errors.maker && "エラー：未入力"}</span>
			
        </>
    )
})

export const ProductsView = (props) => {
    
    const defaultKanta = props.produts.kantakun
    const defaultGaskigu = props.produts.name

    const onChangeProducts = (buyProduts) => {
        props.setProducts(buyProduts)
    }

    return (
        <>
            {
                props.cource === 1 &&
                <>
                <div className="select_desc"> ご購入のガス衣類乾燥機（乾太くん）の情報を入力してください</div>
                <ProductsFormA {...{
                    register:props.register, 
                    defaultKanta, 
                    errors:props.errors,
                    onChangeProducts}}></ProductsFormA>
                </>
            }
            {
                 props.cource === 2 &&
                <>
                <div className="select_desc"> ご購入のガス機器の情報を入力してください</div>
                <ProductsFormB  
                    {...{
                        register:props.register,
                        defaultGaskigu,
                        errors:props.errors,
                        onChangeProducts
                        }}></ProductsFormB>
                </>
            }
        </>
    )
}

